import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import config from 'config'
import StripeCheckout from 'react-stripe-checkout'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { useBilling } from 'ducks/billing/hooks'
import logo from 'assets/groove-logo-v2-circle.png'
import { selectCurrentUser } from 'ducks/currentUser/selectors/selectCurrentUser'
import { DRAWER_TYPE_BILLING_LINK_SHOPIFY } from 'ducks/drawers/types'
import { useDrawer } from 'ducks/drawers/hooks'
import debug from 'util/debug'

const SaveSubscriptionButton = ({ formId: inputFormId, ...buttonProps }) => {
  const formId = inputFormId || 'none'
  const {
    updateCard,
    submitForm,
    updateSubscription,
    primaryCard,
    providerSettings: { hasCardSupport },
    isBillingLinked,
    provider,
    plans,
    billingCycle,
  } = useBilling()
  const currentUser = useSelector(selectCurrentUser)

  const updateCardAndStartSubscription = useCallback(
    async stripeToken => {
      await updateCard(stripeToken)
      if (inputFormId) {
        submitForm(inputFormId)
      } else {
        // If no form id is provided, simply update the subscription using the current
        // subscription fields
        try {
          await updateSubscription(
            {
              pricingIds: plans.map(plan => plan.pricing.id),
              billingCycle,
            },
            { convertTrials: true }
          )
        } catch (error) {
          debug(error)
        }
      }
    },
    [
      inputFormId,
      plans,
      billingCycle,
      submitForm,
      updateCard,
      updateSubscription,
    ]
  )

  const { openDrawer } = useDrawer(DRAWER_TYPE_BILLING_LINK_SHOPIFY)

  const handleInstallShopify = useCallback(
    () => {
      openDrawer('SHOPIFY_V2')
    },
    [openDrawer]
  )

  if (!isBillingLinked && provider === 'shopify') {
    return (
      <Button
        form={formId}
        {...buttonProps}
        htmlType="button"
        disabled={false}
        onClick={handleInstallShopify}
      />
    )
  } else if (!hasCardSupport || primaryCard) {
    return <Button form={formId} {...buttonProps} />
  }
  return (
    <StripeCheckout
      name="Groove HQ"
      image={logo}
      email={currentUser.email}
      billingAddress={false}
      shippingAddress={false}
      zipCode={false}
      allowRememberMe={false}
      token={updateCardAndStartSubscription}
      stripeKey={config.stripePublicKey}
      panelLabel="Save"
    >
      <Button {...buttonProps} htmlType="button" />
    </StripeCheckout>
  )
}

export default SaveSubscriptionButton
